var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{ref:"tips",staticClass:"kye-infotip",style:({ textAlign: _vm.align }),on:{"mouseenter":_vm.tipMouseEnter,"mouseleave":_vm.tipMouseLeave}},[_c('i',{ref:"tchild",class:{ 'kye-infotip_placeholder': !_vm.content && _vm.placeholder }},[_vm._v(_vm._s(_vm.content || _vm.placeholder))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/cache-loader/dist/cjs.js!./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70cdeca6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/public/components/kye-edit-table/tips.vue
// module id = null
// module chunks = 